import { render, staticRenderFns } from "./doc_general.vue?vue&type=template&id=67f3a8b8&scoped=true&"
import script from "./doc_general.vue?vue&type=script&lang=js&"
export * from "./doc_general.vue?vue&type=script&lang=js&"
import style0 from "./doc_general.vue?vue&type=style&index=0&id=67f3a8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3a8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f3a8b8')) {
      api.createRecord('67f3a8b8', component.options)
    } else {
      api.reload('67f3a8b8', component.options)
    }
    module.hot.accept("./doc_general.vue?vue&type=template&id=67f3a8b8&scoped=true&", function () {
      api.rerender('67f3a8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/declaration/item/tabs/doc_general.vue"
export default component.exports